var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { TooltipHighlight } from "../components/tooltip/TooltipHighlight";
import { MultiStepFooter } from "../components/MultiStepFooter";
import { Tooltip } from "../components/tooltip/Tooltip";
var TooltipStep = /** @class */ (function (_super) {
    __extends(TooltipStep, _super);
    function TooltipStep() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderTooltip = function () {
            return _this.props.render ? (_this.invokeRender(_this.props.render)) : (React.createElement(Tooltip, { anchorElement: _this.props.anchorElement, allowedPositions: _this.props.allowedPositions, offset: _this.props.offset, onClose: _this.props.onClose, onSkip: _this.props.onSkip, width: _this.props.width, blueBackground: _this.props.blueBackground, render: function () {
                    return (React.createElement(Tooltip.Container, null,
                        _this.props.image && (React.createElement(Tooltip.Image, null, _this.props.image)),
                        React.createElement(Tooltip.Header, null, _this.props.header),
                        _this.props.content && (React.createElement(Tooltip.Body, null, _this.props.content)),
                        React.createElement(Tooltip.Footer, null, _this.renderTooltipFooter())));
                } }));
        };
        _this.renderTooltipFooter = function () {
            var _a;
            var activeStepIndex = ((_a = _this.props.stepIndex) !== null && _a !== void 0 ? _a : 0) + 1;
            return _this.props.footer ? (_this.invokeRender(_this.props.footer)) : (React.createElement(MultiStepFooter, { blueBackground: _this.props.blueBackground, stepsCount: _this.props.stepsCount, activeStepIndex: activeStepIndex, onPrev: _this.props.onPrev, onNext: _this.props.onNext }));
        };
        _this.invokeRender = function (renderMethod) {
            var _a;
            var props = {
                onNext: _this.props.onNext,
                onPrev: _this.props.onPrev,
                onClose: _this.props.onClose,
                stepsCount: _this.props.stepsCount,
                stepIndex: ((_a = _this.props.stepIndex) !== null && _a !== void 0 ? _a : 0) + 1,
            };
            return renderMethod(props);
        };
        return _this;
    }
    TooltipStep.prototype.render = function () {
        var tooltip = this.renderTooltip();
        var highlightTarget = this.props.highlightTarget || this.props.anchorElement;
        return this.props.highlight ? (React.createElement(TooltipHighlight, { highlight: this.props.highlight, anchorElement: highlightTarget }, tooltip)) : (tooltip);
    };
    return TooltipStep;
}(React.Component));
export { TooltipStep };
